import { GiftOrderStatus, IGiftOrderDetail, ITeacherAddressInfo } from 'kuaidong-model'
import { DateWrapper } from 'kuaidong-lib'

export class GiftOrderService {
  public static formatOrderStatusLabel(status: GiftOrderStatus) {
    switch (status) {
      case GiftOrderStatus.NoAddress:
        return '无地址'

      case GiftOrderStatus.WaitShipped:
        return '待发货'

      case GiftOrderStatus.IsShipping:
        return '发货中'

      case GiftOrderStatus.HasShipped:
        return '已发货'

      default:
        return '已取消'
    }
  }

  public static formatOrderDateTime(dt: string) {
    return new DateWrapper(dt).showStrFullDate
  }

  public static formatGiftRegion(orderDetail: IGiftOrderDetail) {
    return orderDetail.province === orderDetail.city
      ? `${orderDetail.city || ''}${orderDetail.district || ''}`
      : `${orderDetail.province || ''}${orderDetail.city || ''}${orderDetail.district || ''}` || '-'
  }

  public static formatGifFullAddress(orderDetail: ITeacherAddressInfo) {
    return orderDetail.province === orderDetail.city
      ? `${orderDetail.city || ''}${orderDetail.district || ''}${orderDetail.address || ''}`
      : `${orderDetail.province || ''}${orderDetail.city || ''}${orderDetail.district || ''}${
          orderDetail.address || ''
        }`
  }
}
